<template>
    <div class="order-search-modal" @touchmove.prevent>
      <div class="modal-mask">
        <div class="modal-content">
          <div class="modal-header">
            <img src="/eosrent/images/off.png" alt="" @click="close">
          </div>
          <div class="content">
            <h3>{{$t('modal.order-title')}}</h3>
            <div class="input-box">
              <img class="clean" src="/eosrent/images/input-clean.png" @click="cleanClick" alt="" v-show="orderParams">
              <input type="text" :placeholder="$t('modal.order-placeholder')" v-model.trim="orderParams" autofocus="autofocus">
              <p v-show="showOrderCodeError">{{orderCodeError}}</p>
            </div>
            <button type="button" @click="searchClick">{{$t('modal.search-btn')}}</button>
          </div>

        </div>
      </div>

      <loading duration='2s' :isshow='showLoading'></loading>

    </div>
</template>

<script>
import {orderQuery} from './../axios'
import {Utils} from './../utils/patch'
import mixins from './../mixin'

export default {
  props: ['refs'],
  data () {
    return {
      orderParams: null,
      orderCodeError: null,
      showOrderCodeError: false,
      showLoading: false
    }
  },
  mixins: [mixins],
  components: {},
  created () {
    let orderId = Utils.getLocalLast('eosrent_id');
    console.log('created', orderId)
    if (orderId) {
      this.orderParams = orderId;
    }
  },
  mounted () {
  },
  methods: {
    searchClick () {
      if (!this.orderParams) {
        this.showOrderCodeError = true;
        this.orderCodeError = this.$t('modal.order-placeholder');
        return
      }
      let params = {
        id: this.orderParams
      };
      console.log(params)
      this.showLoading = true;
      orderQuery(params)
        .then(result => {
          console.log(result, this.$route, this);
          this.showLoading = false;
          if (this.$route.name === 'details') {
            this.$parent.$parent.refreshClick(params.id);
            this.$router.replace({name: 'details', params: {id: result.id, orderDetails: result}});
          } else {
            this.$router.replace({name: 'details', params: {id: result.id, orderDetails: result}});
          }
          this.close();
        })
        .catch(e => {
          console.log(e, e.response.data);
          this.showLoading = false;
          let error = e.response.data;
          if (error.status === 60004) {
            this.showOrderCodeError = true;
            this.orderCodeError = this.$t('modal.order-error');
          } else {
            this.handlerError(e)
          }
        })
    },
    cleanClick () {
      this.orderParams = '';
    },
    close () {
      this.refs.showModal = false;
    }
  },
  watch: {
    'orderParams': function (newValue, oldValue) {
      if (newValue) {
        this.showOrderCodeError = false;
        this.orderCodeError = '';
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/order_search.vue